<template>
    <v-toolbar
        :color="color"
        fixed        
        app dense cad
        :clipped-left="clipped"
        dark
        >
        <v-toolbar-title class="ml-0 pl-3 cursor" @click="$router.push({path:'/'});">
          <span>{{ title }}</span>
        </v-toolbar-title>  
        <!--<v-toolbar-side-icon dark @click.stop="handleLeftDrawerToggle"></v-toolbar-side-icon>-->
        <!--<v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
        <v-btn icon @click.stop="miniVariant = !miniVariant">
            <v-icon v-html="miniVariant ? 'chevron_right' : 'chevron_left'"></v-icon>
        </v-btn>
        <v-btn dark icon @click.stop="handleLeftMiniVariant">
            <v-icon v-html="miniVariant ? 'fa-angle-right fa-lg' : 'fa-angle-left fa-lg'"></v-icon>
        </v-btn>-->
        <!--<v-btn icon @click.stop="handleLeftClipped">
            <v-icon>fa-archive</v-icon>
        </v-btn>-->                
        <!--<v-btn icon @click.stop="fixed = !fixed">
            <v-icon>remove</v-icon>
        </v-btn>-->
        <!--<v-toolbar-title v-text="title"></v-toolbar-title>-->
        <!--<v-btn dark icon @click="goMarket()">
          <v-icon>view_module</v-icon>
        </v-btn>-->
        <v-spacer></v-spacer>
        <v-btn dark outline @click="prevPage()" icon><v-icon>arrow_back</v-icon></v-btn>
        <v-btn dark outline :disabled="disabledforward" @click="nextPage()" icon><v-icon>arrow_forward</v-icon></v-btn>
        <!--<v-btn dark icon @click="handleFullScreen()">
            <v-icon>fullscreen</v-icon>
        </v-btn>-->
        
      
      
    <!--<v-toolbar-title class="ml-0 pl-3">
      <v-toolbar-side-icon @click.stop="handleDrawerToggle"></v-toolbar-side-icon>
    </v-toolbar-title>
      
      <v-text-field
        flat
        solo-inverted
        prepend-icon="search"
        label="Search"
        class="hidden-sm-and-down"
        >
      </v-text-field>
      <v-spacer></v-spacer>
      <v-btn href="mailto:wangqiangshen@gmail.com">
        Hire Me
      </v-btn>      
      <v-btn icon href="https://github.com/tookit/vue-material-admin">
        <v-icon>fa fa-github</v-icon>
      </v-btn>-->
      
      <!--<v-menu offset-y origin="center center" class="elelvation-2" :nudge-bottom="14" transition="scale-transition">
        <v-btn dark  icon flat slot="activator">
        <v-badge color="red" overlap>
            <span  v-if="notifLength > 0" slot="badge">{{ notifLength }}</span>
          <v-icon medium>notifications</v-icon>
        </v-badge>
        </v-btn>
        <notification-list></notification-list>
      </v-menu>-->
      <v-menu offset-y origin="center center" :nudge-bottom="10" transition="scale-transition">
        <v-btn dark icon large flat slot="activator">
          <v-avatar size="40px" color="cyan">
            <img v-if="user.thumb" :src="user.thumb" :alt="user.name" @error="imgUrlAlt" />
            <span v-else class="white--text">{{user.name ? user.name.charAt(0):null}}</span>
          </v-avatar>          
        </v-btn>
        <v-list class="pa-0">
          <v-list-tile class="py-2" avatar v-bind:to="{path:'/profile/'}">
            <v-list-tile-avatar color="cyan">
              <img v-if="user.thumb" :src="user.thumb" :alt="user.name"  @error="imgUrlAlt"/>
              <span v-else class="white--text">{{user.name ? user.name.charAt(0):null}}</span>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title class="black--text"><strong>{{user.name}}</strong></v-list-tile-title>
              <small>{{profile ? profile.branch.name : null}}</small>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider></v-divider>
          <v-list-tile v-for="(item,index) in items" :to="!item.href ? { name: item.name } : null" :href="item.href" @click="item.click" ripple="ripple" :disabled="item.disabled" :target="item.target" rel="noopener" :key="index">
            <v-list-tile-action v-if="item.icon">
              <v-icon>{{ item.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{ item.title }}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
        </v-list>
          
      </v-menu>
      <!--<v-toolbar-side-icon dark @click.stop="handleRightDrawerToggle"></v-toolbar-side-icon>  -->
      
  </v-toolbar>
</template>
<script>
import config from '@/config'; 
import ls     from '@/util/localStorage';
import NotificationList from '../widgets/list/NotificationList';
import Notif  from '@/util/models/Notif';
import Util   from '@/util';
import user   from '@/util/models/User';
import Model  from '@/apps/main/models/User';

const notif = new Notif();
const model = new Model();

export default {
  name: 'app-toolbar',
  components: {
    NotificationList,
    
  },
  data: () => ({
    disabledforward : false,
    color:config.color,
    notifLength:0,
    title: 'Biz4 Module',
    miniVariant:false,
    clipped: false,
    drawer: true,
    fixed: false,
    rightDrawer: false,
    right: true,
    user : user.attributes(),
    prevUrl : null,
    items: [      
      {
        icon: 'settings',
        href: '#',
        title: 'Settings',
        click: (/*e*/) => {     
            window.getApp.$emit('APP_OPEN_DIALOG_SETTING');        
        }
      },
      {
        icon: 'fullscreen_exit',
        href: '#',
        title: 'Logout',
        click: (/*e*/) => {
            window.getApp.$emit('APP_LOGOUT');
            window.getApp.$emit('showSnackbar', {
                show:true,
                text:'Logout Succesfully.',
                color:'green'
            });
        }
      }
    ],
  }),  
  asyncComputed: {    
    profile(){
      return model.profile().then(res=>{        
        return res.data;        
      });
    },        
  },
  computed: {
    toolbarColor () {
      return this.$vuetify.options.extra.mainNav;
    }
  },
  created () {
      this.user.thumb = this.$config.file('user-thumb', this.user.id);
      var context = this;
      
      context.$store.watch(
          function (state) {
              return state;
          },
          function () {
              notif.all().then(data => {      
                  context.notifLength = data.length;                
              });  
          },
          {
              deep: true //add this if u need to watch object properties change etc.
          }
      );         
  },  
  methods: {
    handleRightDrawerToggle () {
      window.getApp.$emit('APP_RIGHT_DRAWER_TOGGLED');      
    },
    handleLeftDrawerToggle () {
      window.getApp.$emit('APP_LEFT_DRAWER_TOGGLED');      
    },
    handleLeftMiniVariant () {
      window.getApp.$emit('APP_LEFT_MINI_VARIANT'); 
      this.miniVariant = (!this.miniVariant);
    },
    handleLeftClipped () {
      window.getApp.$emit('APP_LEFT_CLIPPED');   
      this.clipped = (!this.clipped);
    },
    handleFullScreen () {
      Util.toggleFullScreen();
    },
    goMarket(){
      ls.set('apps','main');
      //this.$router.push({ path: '/' });
      this.$router.replace({path:'/'});
      this.$router.go(0);
    },    
    nextPage(){            
      this.$router.go(1);
      if(this.prevUrl === this.$route){
        this.disabledforward = true;
      }            
      this.prevUrl = this.$route;
    },
    prevPage(){
      this.$router.go(-1);
      this.disabledforward = false;                  
      this.prevUrl = this.$route;
    },    

    imgUrlAlt(event){
      event.target.src = require('@/assets/img/avatar/man_4.jpg');
    }
  }
};
</script>
